/**
 * The hangar route (Phase 6): the full-bleed showcase scene, or the catalog view when the scene
 * is switched off (`?scene=0`, which the economy e2e uses) or the renderer cannot start.
 */
import { useCallback, useMemo, useState } from 'react';
import { useLocation } from 'react-router';

import { HangarCatalog } from './hangar/HangarCatalog.js';
import { HangarShowcase } from './hangar/Showcase.js';

export function Hangar() {
  const { search } = useLocation();
  const sceneOff = useMemo(() => new URLSearchParams(search).get('scene') === '0', [search]);
  const [failure, setFailure] = useState<string | null>(null);
  const onRendererError = useCallback((message: string) => setFailure(message), []);
  if (sceneOff) return <HangarCatalog notice="The showcase is off; this is the catalog view." />;
  if (failure) {
    return (
      <HangarCatalog
        notice={`The 3D showcase could not start (${failure}); showing the catalog instead.`}
      />
    );
  }
  return <HangarShowcase onRendererError={onRendererError} />;
}
